// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"select-option__wrap--r5KeB","select":"select-option__select--3Ljxh","action":"select-option__action--1z0Is"};